import { statusRepo } from "@repositories";

export async function getStatusOptions(type: "GROUP" | "MISSION" | "VOLUNTEER", organizationId: string) {
  const statusOptions = await statusRepo.find({
    where: {
      type,
      organization: { $id: organizationId },
    },
  });
  return statusOptions;
}
